module.exports = `${require.publicPath}icon08.e8497518.png`;